<a [href]="url$ | async" [class]="class$ | async">
    {{value$ | async}}
</a>